import React from 'react';
import { Autocomplete, TextField, Chip, Box } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedFeeSchedule } from '../../../../../services/ContractService/contractSlice';

const RevCodeRestrictionsEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const selectedFeeSchedule = useAppSelector((state) => state.contract.currentFeeSchedule);

  const handleChange = (event: React.SyntheticEvent, newValue: string[]) => {
    if (selectedFeeSchedule) {
      dispatch(updateSelectedFeeSchedule({
        ...selectedFeeSchedule,
        revCodeRestrictions: newValue
      }));
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Autocomplete
        multiple
        freeSolo
        value={selectedFeeSchedule?.revCodeRestrictions || []}
        onChange={handleChange}
        options={[]} // Empty options array since we allow any value
        renderTags={(value: string[], getTagProps) =>
          value.map((option: string, index: number) => (
            <Chip variant="outlined" label={option} {...getTagProps({ index })} key={index} />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            label="Rev Code Restrictions"
            placeholder="Enter rev codes..."
            size="small"
            variant="outlined"
            helperText="Press Enter to add multiple rev codes"
          />
        )}
      />
    </Box>
  );
};

export default RevCodeRestrictionsEditor;
